export default {
    setDiscipleTree(state, discipleTree) {
        state.discipleTree = discipleTree;
    },
    setError(state, error) {
        state.error = error.toString();
    }
};
